/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc). To make a column queryable by index — including boolean/nullable columns — add a single-column Postgres index and re-run `sf dc`; do not hand-edit generated files.
 */

import { isObject, hasPropOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { RecipeBase } from 'shared/dbo/Recipe';

export interface RecipeIndexedDb {
	id: string;
	title: string;
	producedConsumableId: string;
	producedQuantity: number;
	producedUnitId?: string;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isRecipeIndexedDb = (obj: unknown): obj is RecipeIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (hasPropOfType<{ deleted: boolean }>(obj, 'deleted', 'boolean') && obj.deleted) {
		return true;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ title: unknown }>(obj, 'title') || !(typeof obj.title === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ producedConsumableId: unknown }>(obj, 'producedConsumableId') || !(typeof obj.producedConsumableId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ producedQuantity: unknown }>(obj, 'producedQuantity') || !(typeof obj.producedQuantity === 'number')) {
		return false;
	}
	if (hasPropOfType<{ producedUnitId: unknown }>(obj, 'producedUnitId') && !(typeof obj.producedUnitId === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: RecipeBase): RecipeIndexedDb => ({
	id: obj.id.toString(),
	title: obj.title,
	producedConsumableId: obj.producedConsumableId.toString(),
	producedQuantity: obj.producedQuantity,
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	producedUnitId: obj.producedUnitId == null ? undefined : obj.producedUnitId.toString(),
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: RecipeIndexedDb): RecipeBase => ({
	id: UUID.fromString(obj.id),
	title: obj.title,
	producedConsumableId: UUID.fromString(obj.producedConsumableId),
	producedQuantity: obj.producedQuantity,
	// prettier-ignore
	// eslint-disable-next-line no-eq-null, eqeqeq -- generated: intentional null|undefined (== null) runtime check for the nullable cache form; see #129
	producedUnitId: obj.producedUnitId == null ? undefined : UUID.fromString(obj.producedUnitId),
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdRecipe: LocalDatabaseTableDefinition<RecipeBase, RecipeIndexedDb> = {
	tableName: 'recipes',
	indexColumns: ['producedConsumableId'],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
